import { GetAllInducteesQuery } from "@/__generated__/graphql";
import { useInducteeLanding } from "@/providers/InducteeLandingContext";
import className from "classnames/bind";
import gsap from "gsap";
import { motion, useIsPresent } from "motion/react";
import { useEffect, useRef } from "react";
import InducteesByClassTimeline from "./InducteeByClassTimeline";

import { useLenis } from "lenis/react";
import styles from "./InducteesByClass.module.scss";
const cx = className.bind(styles);

interface InducteesByClassProps {
  inductees: GetAllInducteesQuery["allInductees"];
  primaryCardCta: CTAData;
  onSelectYear: (year?: string) => void;
}

export default function InducteesByClass({
  inductees,
  primaryCardCta,
  onSelectYear,
}: InducteesByClassProps) {
  const rootEl = useRef<HTMLDivElement>(null);
  const isPresent = useIsPresent();
  const { contentEl } = useInducteeLanding();
  const onAnimationStart = async () => {
    lenis?.stop();
  };
  const lenis = useLenis();
  // removed to avoid fixed tab error
  // useEffect(() => {
  //   if (!isPresent) {
  //     gsap.to(contentEl, {
  //       y: 0,
  //       force3D: true,
  //       duration: 0.5,
  //       delay: 0.25,
  //       ease: "power2.out",
  //     });
  //   }
  // }, [isPresent]);
  useEffect(() => {
    lenis?.stop();
  }, [lenis]);
  return (
    <motion.div
      className={cx(["inductees-by-class"])}
      initial={{ opacity: 0.99 }}
      animate={{ opacity: 1 }}
      exit={{ opacity: 0 }}
      onAnimationStart={onAnimationStart}
      ref={rootEl}
      transition={{ duration: 0.3, ease: "easeInOut" }}
    >
      <InducteesByClassTimeline
        inductees={inductees}
        primaryCardCta={primaryCardCta}
        onSelectYear={onSelectYear}
      />
    </motion.div>
  );
}
